/**
 * Yes Human type roles used by the working session room. The classes and CSS
 * variables come from the tenant brand stylesheet the platform loads with
 * `AuthBrandMark markKey="yeshumanWordmark"`.
 */

/** Section labels, figure keys — small caps tracking (sans) */
export const yeshumanAnn = 'yeshuman-label text-[var(--marketing-text)]'

/** Dim labels — AA on paper via `--yeshuman-ink-subtle` */
export const yeshumanAnnDim = 'text-[var(--yeshuman-ink-subtle,var(--marketing-muted))]'

/** Short supporting copy under terms — sans */
export const yeshumanEditorialSm = 'yeshuman-support text-[var(--marketing-muted)]'

/** Term / subsection titles */
export const yeshumanEditorialTerm =
  'yeshuman-sans text-base font-medium leading-snug tracking-[-0.01em] text-[var(--marketing-text)]'

export const yeshumanUiSans = 'yeshuman-sans'
